// Supabase browser client for the Dienstplan app.
// The publishable/anon key is safe in the bundle; per-restaurant access is
// enforced by Postgres Row-Level Security using the signed-in user's JWT claims
// (standort / role / products in app_metadata).
import { createClient } from '@supabase/supabase-js';

const url = process.env.REACT_APP_SUPABASE_URL;
const anonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  // Surfaced loudly in dev; in prod the env vars are baked at build time.
  // eslint-disable-next-line no-console
  console.error(
    'Supabase config missing: set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in frontend/.env.local',
  );
}

export const supabase = createClient(url ?? '', anonKey ?? '', {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    // Distinct storage key so a Skonto build on the same origin can't collide.
    storageKey: 'dienstplan-auth',
  },
});
